import DOMPurify from "dompurify";
import { type Directive, type DirectiveHook } from "vue";

const SANITIZE_OPTIONS = {
  ADD_TAGS: ["katex", "katex-inline", "iframe"],
  ADD_ATTR: ["content", "target", "float", "blobsid"],
};

const sanitize: DirectiveHook = (el, { oldValue, value }) => {
  if (value !== oldValue) {
    const cleanHtml = DOMPurify.sanitize(value, SANITIZE_OPTIONS);
    el.innerHTML = cleanHtml;
  }
};

/**
 * Vue directive to sanitize HTML content.
 * This directive can be used to safely insert HTML into a Vue component.
 * It uses DOMPurify to sanitize the HTML content and prevent XSS attacks.
 *
 * @example
 * <template>
 *   <div v-safe-html="htmlContent"></div>
 * </template>
 */
const directive: Directive = {
  beforeMount: sanitize,
  beforeUpdate: sanitize,
};

export default directive;
